import type { IImageFields } from 'types/generated/contentful';
import { getContentfulAssetImageProps } from './getContentfulAssetImageProps';

export const getContentfulImageProps = (image: IImageFields) => ({
  alt: image.alt,
  decoration: image.decoration,
  ...getContentfulAssetImageProps(image.image),
});
